<template>
  <Menu :active-name="idx" :open-names="subIdx" width="auto" v-if="siderArr && siderArr.length">
    <template v-for="(item, index) in siderArr">
      <MenuItem :name="index" :key="'side-' + index" v-if="item.type === 1" @click.native="linkToRouter(item.router)" :class="item.title == '首页'?'layout_shouye':''">
      <div class="sider-item">
        <i class="icon iconfont" :class="item.icon"></i>
        <span class="sider-txt">{{item.title}}</span>
      </div>
      </MenuItem>
      <template v-if="item.type === 2">
        <Submenu :name="index" :key="'side2-' + index">
          <div class="sider-item" slot="title">
            <i class="icon iconfont" :class="item.icon"></i>
            <span class="sider-txt">{{item.title}}</span>
          </div>
          <MenuItem :name="index+ '-' + i" v-for="(sub, i) in item.children" :key="'subside-' + i" @click.native="linkToRouter(sub.router)">{{sub.title}}</MenuItem>
        </Submenu>
      </template>
    </template>
  </Menu>
</template>

<script>
export default {
  props: {
    siderArr: {
      type: Array,
      default: []
    }
  },
  name: "gSide",
  data () {
    return {
      idx: "0", // 当前路由索引值
      subIdx: [0] // 当前路由索引值
    };
  },
  computed: {
    path () {
      return this.$route.path;
    }
  },
  created () {
    this.setIndex(this.path);
  },
  watch: {
    $route (to, from) {
      setTimeout(() => {
        this.setIndex(to.path);
      }, 400);
    }
  },
  methods: {
    linkToRouter (url) {
      if (url.indexOf('http') !== -1 || url.indexOf('https') !== -1) {
        window.open(url);
      } else {
        this.$router.push(url);
      }
    },
    setIndex (path) {
      let subIndex = [];
      this.siderArr.forEach((c, idx) => {
        if (c.type === 1) {
          if (path === c.router) {
            this.idx = idx;
            subIndex.push(idx);
          }
        }
        if (c.type === 2) {
          subIndex.push(idx);
          c.children.forEach((v, index) => {
            if (path.indexOf(v.router) !== -1) {
              this.idx = idx + "-" + index;
            }
          });
        }
      });
      if (this.subIdx.length !== subIndex.length) {
        this.subIdx = subIndex;
      }
    }
  }
};
</script>

<style lang="scss">
.layout_shouye {
  margin-bottom: 1px;
}
</style>
<style scoped lang="scss">
.sider-item {
  width: 100%;
  display: flex;
  align-items: center;
  i {
    font-size: 20px;
  }
  span {
    flex: 1;
  }
}
.icon-diamonds {
  font-size: 19px !important;
}
</style>
